import React, { Fragment, useEffect, useState } from 'react'
import { observer, inject } from 'mobx-react'
import { toJS } from 'mobx'
import { MoreVert } from 'iconoir-react'
import moment from 'moment'
import SkeletonNotification from '../../components/Skeleton/SkeletonNotification'
import { useCallback } from 'react'
import { NOTIFICATION_STATUS } from '../../utils/constants'
import { useNavigate } from 'react-router-dom'
import InfiniteScroll from 'react-infinite-scroll-component'
import { Spin } from 'antd'
const NotificationGeneral = ({ notificationStore }) => {
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()
  const [items, setItems] = useState([])
  const [isFilterUnread] = useState(false)
  //   const [isLoadingNotification, setIsLoadingNotification] = useState(false)
  let only_news_notification = true

  useEffect(() => {
    ;(async () => {
      setLoading(true)
      try {
        notificationStore.clearStore()
        await Promise.all([
          notificationStore.getCurrentUserNotification(only_news_notification),
        ])
      } catch (err) {
        console.log(err)
      } finally {
        setLoading(false)
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  let notificationList = toJS(notificationStore.notificationList)

  /** Xử lý đã đọc thông báo */
  const handleReadNotify = useCallback(
    (id, status, num) => {
      if (status && num === 0) {
        // message.warning('Thông báo đã được đọc!')
        return
      }
      if (status) return
      //   setIsLoadingNotification(true)
      notificationStore.readNotification(id).then(() => {
        if (isFilterUnread) {
          const itemsList = items.filter(el => el.id !== id)
          setItems(itemsList)
        } else {
          const itemsList = [...items]
          const indexReadItem = items.findIndex(item => item.id === id)
          const itemReplace = {
            ...items[indexReadItem],
            status: true,
          }
          itemsList.splice(indexReadItem, 1, itemReplace)
          setItems([...itemsList])
        }
        //   message.success('Thông báo được đánh dấu đã đọc!')
      })
      // .finally(() => setIsLoadingNotification(false))
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [items]
  )

  const goToContentNotification = async (type, id) => {
    switch (type) {
      case NOTIFICATION_STATUS.NEWS:
        return navigate(`/utility/general-notifications/view/${id}`)
      default:
        return
    }
  }

  const [hasMore, setHasMore] = useState(false)
  const fetchMoreData = async () => {
    if (
      notificationList.length >= notificationStore.notificationListTotalCount
    ) {
      setHasMore(false)
      return
    }
    notificationStore.notificationListPageIndex =
      notificationStore.notificationListPageIndex + 1

    try {
      await notificationStore.getCurrentUserNotification(only_news_notification)
    } catch (err) {
      console.log(err)
    } finally {
      setHasMore(false)
    }
  }

  return (
    <div className="custom-pagination">
      {loading ? (
        <SkeletonNotification />
      ) : (
        <Fragment>
          <InfiniteScroll
            dataLength={notificationList.length}
            next={fetchMoreData}
            hasMore={hasMore}
            style={{
              scrollSnapStop: 'always',
            }}
            scrollableTarget="infinityScrollableDiv"
            loader={
              <div
                style={{
                  paddingTop: 20,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}>
                {hasMore ? <Spin tip="Đang tải..." /> : ''}
              </div>
            }>
            <div>
              {notificationList?.map((item, index) => {
                return (
                  <div
                    key={index}
                    className="relative bg-[#F8F8F8] rounded-lg p-3.5 mt-5"
                    onClick={() => {
                      handleReadNotify(item.id, item.status, 1)
                      goToContentNotification(item.type, item.code)
                    }}>
                    {item.status === false ? (
                      <div className="absolute right-2 top-2 w-2 h-2 bg-[#0073C7] rounded-full" />
                    ) : (
                      ''
                    )}
                    {item.status === false ? (
                      <div
                        className="font-bold text-sm"
                        dangerouslySetInnerHTML={{ __html: item.content }}
                      />
                    ) : (
                      <div
                        className="text-sm"
                        dangerouslySetInnerHTML={{ __html: item.content }}
                      />
                    )}
                    <div className="my-3.5 flex justify-between">
                      <div className="text-xs mr-1">
                        {moment(item.time_created).format('dddd', 'vi')},{' '}
                        {moment(item.time_created).format('L')} lúc{' '}
                        {moment(item.time_created).format('LT', 'vi')}
                      </div>
                      <div>
                        <MoreVert />
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          </InfiniteScroll>
        </Fragment>
      )}
    </div>
  )
}

export default inject('notificationStore')(observer(NotificationGeneral))
